import { get } from "./fetch.core";

export async function getAdminInfo() {
  const res = await get<any>("/admin/me");

  return res.data;
}
